import { Link, useParams, useSearchParams } from 'react-router';
import { tx } from '../i18n';
import { ConsolaSsh } from '../ui/ConsolaSsh';
import { Cabecera } from '../ui/piezas';

/**
 * La consola de un appliance a pantalla completa. Es la que se abre desde un libre (que
 * todavía no tiene página propia); a los demás se entra también desde su pestaña Consola.
 */
export function Consola() {
  const { id = '' } = useParams();
  const [params] = useSearchParams();
  const nombre = params.get('nombre') || tx.comun.appliance;
  return (
    <div className="pagina">
      <Cabecera
        titulo={tx.consola.titulo(nombre)}
        accion={
          <Link className="btn" to="/appliances">
            {tx.comun.appliances}
          </Link>
        }
      >
        {tx.consola.que}
      </Cabecera>
      <ConsolaSsh applianceId={id} nombre={nombre} conTitulo={false} />
    </div>
  );
}
